<script>
    import { res, state, ui, prefs, live } from './stores.js';
    import Preview from './Preview.svelte';
    import { isSelected, toggleSelect } from './ui.js';
    import { get, set } from 'idb-keyval';
    import SimpleCard from './SimpleCard.svelte';
    import { genCard } from './game.js';
    import Mousetrap from 'mousetrap';
    import FullPage from './FullPage.svelte';
    import DeckLook from './DeckLook.svelte';
    import { draggable } from 'svelte-drag';

    import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
    let useImages = true;

    Mousetrap.bind('up', moveUp);
    Mousetrap.bind('down', moveDown);
    Mousetrap.bind('left', moveLeft);
    Mousetrap.bind('right', moveRight);
    Mousetrap.bind('shift+left', shiftLeft);
    Mousetrap.bind('shift+right', shiftRight);
    Mousetrap.bind('f', cardSearch);
    Mousetrap.bind('s', (e) => {toTier('S')});
    Mousetrap.bind('a', (e) => {toTier('A')});
    Mousetrap.bind('b', (e) => {toTier('B')});
    Mousetrap.bind('c', (e) => {toTier('C')});
    Mousetrap.bind('d', (e) => {toTier('D')});
    Mousetrap.bind('x', (e) => {toTier('X (dunno)')});

    let looking = false;

    function toTier(t){
        let c = currentCard();
        if(!c) return;
        moveTo(c, 'tier', t);
    }

    function moveUp(){
        let c = currentCard();
        if(!c) return;
        if(cardLog[c.id].place == 'deck'){
            moveTo(c, 'tier', 'X (dunno)');
        }else{
            let t = cardLog[c.id].deck;
            let keys = Object.keys(tiers);
            let index = keys.indexOf(t);
            if(index != -1 && index > 0){
                moveTo(c, 'tier', keys[index-1]);
            }
        }
    }

    function moveDown(){
        let c = currentCard();
        if(!c) return;
        if(cardLog[c.id].place == 'X (dunno)'){
            moveTo(c, 'deck', c.deck);
        }else{
            let t = cardLog[c.id].deck;
            let keys = Object.keys(tiers);
            let index = keys.indexOf(t);
            if(index != -1 && index < keys.length -1){
                moveTo(c, 'tier', keys[index+1]);
            }
        }
    }

    function moveLeft(){
        if(!$ui.selected) shiftLeft();
        let c = $ui.selected;
        if(!c) return;
        let index = cardLog[c.id].index;
        let d = getDeck(c);
        if(index == 0){
            $ui.selected = d[d.length - 1];
        }else{
            $ui.selected = d[index - 1];
        }
    }

    function moveRight(){
        if(!$ui.selected) shiftRight();
        let c = $ui.selected;
        if(!c) return;
        let index = cardLog[c.id].index;
        let d = getDeck(c);
        if(index == d.length - 1){
            $ui.selected = d[0];
        }else{
            $ui.selected = d[index + 1];
        }
    }

    function shiftLeft(){
        let c = currentCard();
        if(!c) return;
        let {place, deck, index} = cardLog[c.id];
        let toIndex = index + 1;
        let d = getDeck(c);
        if(toIndex >= d.length) toIndex = 0;
        moveTo(c, place, deck, toIndex);
    }

    function shiftRight(){
        let c = currentCard();
        if(!c) return;
        let {place, deck, index} = cardLog[c.id];
        let toIndex = index - 1;
        let d = getDeck(c);
        if(toIndex <= 0) toIndex = d.length - 1;
        moveTo(c, place, deck, toIndex);
    }

    function getDeck(c){
        if(cardLog[c.id].place == 'deck'){
            return decks[cardLog[c.id].deck];
        }
        return tiers[cardLog[c.id].deck];
    }

    let tiers = {
        S: [],
        A: [],
        B: [],
        C: [],
        D: [],
        'X (dunno)': []
    }
    

    let decks = {};
    let cardLog = {};
    let scale = 0.8;

    let deckNames = Array.from(new Set($res.cards.filter(c => c.deck).map(c => c.deck))).sort((a,b) => a.localeCompare(b));
    let chosenDeckName = deckNames[0];
    
    // Need to set up game really first to make this work...!


    function currentCard(){
        if($live.previewCard) return $live.previewCard;
        if($live.hoveringCard) return $live.hoveringCard;
        if($ui.selection) return $ui.selection;
        return false;
    }

    export async function cardSearch(){
        console.log('searching');
        let text = prompt(`Search for:`);
        if(!text) return;
        let cards = $res.cards.filter(c => c.name.toLowerCase().includes(text.toLowerCase()));
        looking = cards;
    }

    function fromScratch(){
        for(let d of deckNames){
            decks[d] = [];
            for(let c of $res.cards){
                if(c.deck == d){
                    let cd = genCard(c);
                    decks[d].push(cd);
                    cardLog[cd.id] = {
                        place: 'deck',
                        deck: d,
                        index: decks[d].indexOf(cd)
                    }
                }
            }
        }

        for(let d of deckNames){
            decks[d] = decks[d].sort((a, b) => a.name.localeCompare(b.name));
        }
    }
    
    let actions = [];
    for(let t of Object.keys(tiers)){
        actions.push({
            text: t,
            show: (c) => {
                if(cardLog[c.id].place == 'tiers' && cardLog[c.id].deck == t) return false;
                return true;
            },
            func: (c) => {
                moveTo(c, 'tiers', t);
            }
        })
    }

    actions.push({
        text: 'Back to deck',
        show: (c) => {
            if(cardLog[c.id].place == 'deck') return false;
                return true;
        },
        func: (c) => {
            moveTo(c, 'deck', c.deck);
        }
    })
    

    function moveTo(c, toPlace, toDeck, toIndex = -1){
        let {place, deck, index} = cardLog[c.id];
        if(place == 'deck'){
            decks[deck] = decks[deck].filter(cd => cd.id != c.id);
        }else{
            tiers[deck] = tiers[deck].filter(cd => cd.id != c.id);
        }

        if(toPlace == 'deck'){
            if(toIndex == -1) toIndex = decks[toDeck].length;
            decks[toDeck] = [...decks[toDeck].slice(0, toIndex), c, ...decks[toDeck].slice(toIndex)];
        }else{
            tiers[toDeck] = [...tiers[toDeck].slice(0, toIndex), c, ...tiers[toDeck].slice(toIndex)];
        }

        cardLog[c.id] = {
            place: toPlace,
            deck: toDeck,
            index: toIndex
        };

        $ui.selected = false;
        saved = false;
    }

    let saved = false;

    async function save(){
        let tiersToSave = {};
        for(let k of Object.keys(tiers)){
            let arr = [];
            for(let c of tiers[k]){
                arr.push({
                    id: c.id,
                    deck: c.deck,
                    name: c.name
                });
            }
            tiersToSave[k] = arr;
        }
        try{
            await set('tiers', {
                tiersToSave,
                cardLog
            });
            saved = true;
        }catch(e){
            alert('Unable to save');
            console.log(e);
        }
    }

    async function load(){
        fromScratch();

        let obj = await get('tiers');
        console.log(obj);
        if(!obj) return;
        let tiersToLoad = obj.tiersToSave;
        cardLog = obj.cardLog;

        for(let k of Object.keys(tiersToLoad)){
            let arr = [];
            for(let c of tiersToLoad[k]){
                let card = $res.cards.find(cd => cd.id == c.id);
                if(!card){
                    card = $res.cards.find(cd => cd.deck == c.deck && cd.name == c.name);
                    if(card) cardLog[card.id] = cardLog[c.id]; // Replace it
                }
                if(card){
                    arr.push(card);
                }
            }
            tiers[k] = arr;
        }
        saved = true;
    }

    load();

</script>
<FullPage>
    <div slot="top" style="justify-content: flex-start; flex-gap: 5px;">
        <button on:click={e => {dispatch('setup')}}>Return to menu</button>
        Card scale: <input type="number" bind:value={scale} min={0.1} max={2} step={0.1} />
        <input type="checkbox" bind:checked={$prefs.useCardImages} /> Use card images?
        Add from deck:
        <select bind:value={chosenDeckName}>
            {#each deckNames as d}
                <option value={d}>{d}</option>
            {/each}
        </select>
        <!--<button on:click={cardSearch}>Find card</button>-->
        <button on:click={e => {looking = decks[chosenDeckName]}}>Open deck</button>
        {#if !saved}
            <button on:click={save}>Save list</button>
            <button on:click={e => {if(confirm('Really discard changes and reload?')) load();}}>Load from save</button>
        {:else}
            Changes saved
        {/if}
    </div>
    <div slot="main"><table style="height: {90 - $res.cardHeight * $prefs.cardScale * scale}vmin; width:100vw;">
        {#each Object.keys(tiers) as t}
            <tr style="height: {$res.cardHeight * $prefs.cardScale * scale}vmin;">
                <td class="mid {t}">{t} tier:</td>
                <td class="{t}" style="display: inline-flex; min-width: 80vw; height: {$res.cardHeight * $prefs.cardScale * scale}vmin;">
                    {#each tiers[t] as c}
                        <div><SimpleCard {c} {actions} {scale} {useImages}/></div>
                    {/each}
                </td>
            </tr>
        {/each}
    </table>
</div>
</FullPage>
{#if looking}
    <div>
        <div class="look" use:draggable>
            <div class="look_row">{chosenDeckName} deck <button on:click={e => {looking = false} }>Close</button></div>
            <div class="look_row" style="max-height: 50vh; max-width: 60vw; overflow: scroll;">
                {#each looking as c}
                    {#if cardLog[c.id] && cardLog[c.id].place == 'deck'}
                        <div><SimpleCard {c} {actions} {scale} {useImages}/></div>
                    {/if}
                {/each}
            </div>
        </div>
    </div>
{/if}
<Preview force useImages={false}/>

<style>
    .hover {
        position:fixed;
        right: 0;
        bottom: 0;
    }
    .mid {
        text-align: center;
    }
    .S {
        background-color: red;
        color: white;
    }
    .A {
        background-color: salmon;
        color: black;
    }
    .B {
        background-color: orange;
        color: black;
    }
    .C {
        background-color: yellow;
        color: black;
    }
    .D {
        background-color: brown;
        color: white;
    }
    .X {
        background-color: green;
        color: white;
    }

    .look {
        border: 1px solid white;
		position: fixed;
		z-index: 500;
		left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        pointer-events: visible;
		padding: 3vmin;
		padding-bottom: 1vmin;
		/*transform: translate(-50%, -50%);*/
        height: fit-content;
        width: fit-content;
		max-height: 90vh;
		max-width: 90vw;
		min-width: 60vw;
		/*padding: 3vmin;*/
		padding-bottom: 1vmin;
		transform: translate(-50%, -50%);
		max-height: 90vh;
		max-width: 90vw;
		overflow-y: auto;
		backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
		color: black;
		/*box-shadow: 0 0 5px 5px black;*/
        color: white;
	}
    .look_row {
		width: 100%;
		font-size: 2vmin;
		display: flex;
        max-width: 90vw;
        flex-wrap: wrap;
		align-items: center;
		justify-content: start;
        font-weight: bold;
		/*padding: 1vmin;*/
	}
</style>